export default __webpack_public_path__ + "static/media/logo.652a4607.svg";